<div class="container">
  <div class="offset-scale-wrapper">
    <div class="offset">
      <span class="offset-text">OFFSET</span>
      <span class="sign" [innerHTML]="vm.getMeasureTypeSign()"> </span>
      <div class="offset-input-warpper">
        <input
          class="layer-input"
          type="number"
          min="0"
          step="1"
          (keydown)="vm.validateInput($event)"
          (paste)="vm.validateOnPasteEvent($event)"
          (change)="vm.inputFieldUpdatedEventHandler('x', $event)"
          [value]="vm.x | number: vm.getFloatingTimeFormat() | removeComma"
        />
        <span class="type-layer">X</span>
      </div>
      <div class="offset-input-warpper">
        <input
          class="layer-input"
          type="number"
          min="0"
          step="1"
          (keydown)="vm.validateInput($event)"
          (paste)="vm.validateOnPasteEvent($event)"
          (change)="vm.inputFieldUpdatedEventHandler('y', $event)"
          [value]="vm.y | number: vm.getFloatingTimeFormat() | removeComma"
        />
        <span class="type-layer">Y</span>
      </div>
    </div>
    <div class="scale">
      <span class="scale-text">SIZE</span>
      <span class="sign" [innerHTML]="vm.getMeasureTypeSign()"></span>
      <div class="scale-input-warpper">
        <!--<input class="layer-input" type="number" min="0" step="1" (change)="vm.inputFieldUpdatedEventHandler('width', $event)" [value]="vm.width | number: '1.0-0' | removeComma">-->
        <input
          class="layer-input"
          type="number"
          min="0"
          step="1"
          (keydown)="vm.validateInput($event)"
          (paste)="vm.validateOnPasteEvent($event)"
          (change)="vm.inputFieldUpdatedEventHandler('width', $event)"
          [value]="vm.width | number: vm.getFloatingTimeFormat() | removeComma"
        />
        <span class="type-layer">W</span>
      </div>
      <div class="scale-input-warpper">
        <input
          class="layer-input"
          type="number"
          min="0"
          step="1"
          (keydown)="vm.validateInput($event)"
          (paste)="vm.validateOnPasteEvent($event)"
          (change)="vm.inputFieldUpdatedEventHandler('height', $event)"
          [value]="vm.height | number: vm.getFloatingTimeFormat() | removeComma"
        />
        <span class="type-layer">H</span>
      </div>
    </div>
  </div>
  <div class="type-dropdown-wrapper" *ngIf="vm.showMeasureTypeSelection">
    <select
      class="type-dropdown"
      [(ngModel)]="vm.selectedMeasureType"
      (change)="vm.measureTypesChangedEventHandler()"
    >
      <option
        *ngFor="let measureType of vm.measureTypes"
        [value]="measureType.id"
        [selected]="measureType.id === vm.selectedMeasureType"
      >
        {{ measureType.displayName }}
      </option>
    </select>
  </div>
</div>
